import * as React from "react";
import NewCompetitor from "../prefabs/NewCompetitor";
import {
  Block,
  Page,
  Navbar,
  NavLeft,
  NavTitle,
  Link,
  BlockTitle,
  NavRight,
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  Col,
  List,
  ListItem,
  Row,
  Icon,
  AccordionContent,
  Button,
} from "framework7-react";
import { API_URL, GET_FILTER } from "src/utils/constants";
import { api, getToken } from "src/utils/utils";
import { EventEmmiter } from "src/utils/events.js";
import ProductsCompetitors from "../prefabs/ProductsCompetitors";
import ListProductsCompete from "../prefabs/ListProductsCompete";

export default class CompetitorsPage extends React.Component {
  public state = {
    loading: false as boolean,
    competitors: [] as any[],
  };

  public componentDidMount() {
    this.$f7?.tooltip.create({
      targetEl: ".addCompetitor",
      text: "Agregar Nuevo Competidor",
    });

    this.handleData();

    EventEmmiter.subscribe("competitorAdded", (event: any) => {
      const newState = this.state.competitors;
      newState.unshift(event);
      this.setState({
        competitors: newState,
      });
    });
  }

  public async handleData() {
    if (getToken() == null) {
      return;
    }

    this.setState({
      loading: true,
    });
    const dialog = this.$f7?.dialog.preloader("Cargando competidores");
    dialog?.open();

    const filter = {
      table: "competitors",
      where: {
        status: 1,
      },
      order: "id desc",
    };
    const data = await api.get<any[]>(
      API_URL + GET_FILTER + encodeURIComponent(JSON.stringify(filter)),
      {}
    );
    this.setState({
      competitors: data,
      loading: false,
    });

    setTimeout(() => {
      dialog?.close();
    }, 500);
  }

  public render() {
    return (
      <Page>
        <Navbar>
          <NavLeft leftBreakpoint={800}>
            <Link panelOpen="left">
              <i className="icon icon-menu" />
            </Link>
          </NavLeft>
          <NavTitle>Competidores</NavTitle>
          <NavRight>
            <Link className="addCompetitor" popupOpen=".new-competitor-popup">
              <i className="icon icon-plus" />
            </Link>
          </NavRight>
        </Navbar>
        <BlockTitle>Monitoreo de Competidores</BlockTitle>
        <Block>
          <h1>Competidores</h1>
        </Block>
        <Block>
          <Row resizable={true}>
            {!this.state.competitors.length && !this.state.loading && (
              <h2>Sin Competidores registrados</h2>
            )}
            {this.state.competitors.length &&
              this.state.competitors.map((item: any) => {
                return (
                  <Col key={item.id} width="100">
                    <Card outline={true}>
                      <CardHeader>
                        <div className="fb">{item.storeName}</div>
                      </CardHeader>
                      <CardContent padding={false}>
                        <List accordionList>
                          <ListItem accordionItem title="Ver Detalles">
                            <AccordionContent>
                              <Row>
                                <Col width="100">
                                  <List mediaList>
                                    <ListItem
                                      header="Reputación"
                                      text="MercadoLíder Platinum"
                                      subtitle={
                                        item.totalSales +
                                        " ventas en los últimos 365 días"
                                      }
                                    />
                                    <ListItem subtitle={"✅ " + item.metric1} />
                                    <ListItem subtitle={"✅ " + item.metric2} />
                                  </List>
                                </Col>

                                <Col width="100">
                                  <Row>
                                    <Col width="33">
                                      <List mediaList>
                                        <ListItem
                                          header="Total Opiniones"
                                          subtitle={item.buyersFeedback}
                                        />
                                      </List>
                                    </Col>
                                    <Col width="33">
                                      <List mediaList>
                                        <ListItem
                                          header="No. de Productos"
                                          subtitle="??"
                                        />
                                      </List>
                                    </Col>
                                    <Col width="33">
                                      <List mediaList>
                                        <ListItem
                                          header="No. de Páginas"
                                          subtitle="??"
                                        />
                                      </List>
                                    </Col>
                                  </Row>
                                </Col>

                                <Col width="100">
                                  <Row>
                                    <Col width="33">
                                      <List mediaList>
                                        <ListItem
                                          header="Ops. Buenas"
                                          subtitle={item.feedbackGood}
                                        />
                                      </List>
                                    </Col>
                                    <Col width="33">
                                      <List mediaList>
                                        <ListItem
                                          header="Ops. Regulares"
                                          subtitle={item.feedbackRegular}
                                        />
                                      </List>
                                    </Col>
                                    <Col width="33">
                                      <List mediaList>
                                        <ListItem
                                          header="Ops. Malas"
                                          subtitle={item.feedbackBad}
                                        />
                                      </List>
                                    </Col>
                                  </Row>
                                </Col>
                              </Row>
                              <Block>
                                <Row width="100">
                                  <Col width="50">
                                    <Button
                                      fill
                                      onClick={(e: any) =>
                                        this.openProducts(item)
                                      }
                                      color="green"
                                      className="font__5"
                                      raised
                                    >
                                      Ver Productos
                                    </Button>
                                  </Col>
                                  <Col width="50">
                                    <Button
                                      onClick={(e: any) =>
                                        // @ts-ignore
                                        window.open(item.link, "_blank")
                                      }
                                      fill
                                      color="yellow"
                                      className="font__5"
                                      raised
                                    >
                                      Ver en Mercadolibre
                                    </Button>
                                  </Col>
                                </Row>
                                <br />
                              </Block>
                            </AccordionContent>
                          </ListItem>
                        </List>
                      </CardContent>
                      <CardFooter>
                        <div>
                          <Icon slot="media" icon="icon icon-map-pin icon-sm" />
                          {item.ubication}
                        </div>
                      </CardFooter>
                    </Card>
                  </Col>
                );
              })}
          </Row>
        </Block>
        <NewCompetitor />
        <ProductsCompetitors />
        <ListProductsCompete />
      </Page>
    );
  }

  public openProducts(item: any) {
    console.log(item);

    EventEmmiter.dispatch("hook-competitors-popup", item);
    this.$f7?.popup.open(".products-competitors-popup");
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/CompetitorsPage.tsx